/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `active` - Aktywny
 * * `suspended` - Wstrzymany
 * * `finished` - Zakończony
 */
export type CurriculumEnrollmentStateEnum = typeof CurriculumEnrollmentStateEnum[keyof typeof CurriculumEnrollmentStateEnum];


export const CurriculumEnrollmentStateEnum = {
  active: 'active',
  suspended: 'suspended',
  finished: 'finished',
} as const;
